import { FormHelperText, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { StyledTextField } from "../../TextField/TextField";

export default function PeopleMatterAPISection(props) {
  const useStyles = makeStyles((theme) => ({
    error: {
      color: theme.palette.error.main,
    },
    textField: {
      "& .Mui-error": {
        color: theme.palette.error.main,
      },
      "& .MuiFormHelperText-root": {
        color: theme.palette.error.main,
      },
      "& .MuiInput-underline.Mui-error:after": {
        borderBottomColor: theme.palette.error.main,
      },
    },
  }));

  const classes = useStyles();
  return (
    <>
      <Grid item xs={12} sm={6}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Company Name"
          value={props.companyName}
          error={props.showInputError && props.companyName === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setCompanyName(e.target.value)}
        />
        {props.showInputError && props.companyName === "" && (
          <FormHelperText className={classes.error}>Company Name Required</FormHelperText>
        )}
      </Grid>
      <Grid item xs={12} sm={6}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Business Units"
          value={props.businessUnits}
          error={props.showInputError && props.businessUnits === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setBusinessUnits(e.target.value)}
        />
        {props.showInputError && props.businessUnits === "" && (
          <FormHelperText className={classes.error}>Business Units Required</FormHelperText>
        )}
      </Grid>
    </>
  );
}
